import React from 'react';
import { Segment } from 'semantic-ui-react';

const WeatherError = () => (
	<Segment
		inverted
		raised
		textAlign="center"
		color="red"
		style={{ marginBottom: '-5px' }}
	>
		ERROR FETCHING DATA
	</Segment>
);

export default WeatherError;



// WEBPACK FOOTER //
// ./src/components/WeatherError.js